// extracted by mini-css-extract-plugin
export default {"summary-container":"MedicineWiseStockAuditReportSummary_summary-container__VqdXv","summary-ctas":"MedicineWiseStockAuditReportSummary_summary-ctas__QFtXZ"};